import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

/** TwoColumnLayoutSecondary is the wrapper for the secondary (smaller) section of a layout. */
const TwoColumnLayoutSecondary = props => {
  const { className, children, ...other } = props;

  return (
    <div className={clsx("em-l__secondary", className)} {...other}>
      {children}
    </div>
  );
};

TwoColumnLayoutSecondary.propTypes = {
  /** children of the container */
  children: PropTypes.node,
  /** Additional css classes to append to the outer element */
  className: PropTypes.string
};

TwoColumnLayoutSecondary.defaultProps = {
  children: null,
  className: ""
};

export default TwoColumnLayoutSecondary;
